import type { ReactElement } from 'react';

import { presentWhatsAppInboxDocument } from '@/features/notification/lib/whatsapp-inbox-document.js';

export interface WhatsAppInboxDocumentCardProps {
  readonly filename: string;
  readonly mimetype: string;
  readonly href: string | null;
  readonly detail?: string;
}

export function WhatsAppInboxDocumentCard({
  filename,
  mimetype,
  href,
  detail,
}: WhatsAppInboxDocumentCardProps): ReactElement {
  const presentation = presentWhatsAppInboxDocument(filename, mimetype);
  const subtitle =
    detail !== undefined && detail.length > 0
      ? `${presentation.subtitle} · ${detail}`
      : presentation.subtitle;
  const body = (
    <>
      <span className="whatsapp-inbox-doc__badge" data-kind={presentation.kind}>
        {presentation.badge}
      </span>
      <span className="whatsapp-inbox-doc__meta">
        <strong className="whatsapp-inbox-doc__title">{presentation.title}</strong>
        <span className="whatsapp-inbox-doc__subtitle">{subtitle}</span>
      </span>
    </>
  );

  if (href === null) {
    return <div className="whatsapp-inbox-doc">{body}</div>;
  }

  return (
    <a
      className="whatsapp-inbox-doc"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Abrir ${presentation.title}`}
    >
      {body}
    </a>
  );
}
